export default __webpack_public_path__ + "static/media/DemarrSneaker_Wide.91a85f8e.jpg";